<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2 md:grid-cols-3">
                <div
                    class="relative col-span-1 flex shadow rounded-md"
                    v-for="(student, studentIndex) in group.students"
                    :key="student.id"
                >
                    <div
                        class="shrink-0 flex items-center justify-center w-16 text-white text-sm leading-5 font-medium rounded-l-md overflow-hidden"
                    >
                        <a :href="student.links.show">
                            <img :src="student.avatar_or_default" alt="profile photo" />
                        </a>
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                    >
                        <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
                            <a
                                :href="student.links.show"
                                class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
                            >
                                {{ studentIndex + 1 }}. {{ student.full_name }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'group'],
    data() {
        return {};
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
